var $ = require('../internals/export');
var isArray = require('../internals/is-array');

// `Array.isArray` method
// https://tc39.github.io/ecma262/#sec-array.isarray
$({ target: 'Array', stat: true }, {
  isArray: isArray
});



// WEBPACK FOOTER //
// /Users/kinfirm/Sites/mvgroup/wp-content/themes/mvgroup/node_modules/core-js/modules/es.array.is-array.js